<div class="modal-container">
  <div class="modal-icon">
    <i class="bi bi-exclamation-circle icon-warning"></i>
  </div>

  <h2 class="modal-title">Confirmar datos</h2>
  <p class="modal-text">
    Al realizar esta acción, después no podrás cambiar la información.
  </p>

  <div class="modal-actions">
    <button mat-stroked-button color="primary" (click)="cerrar()">
      Seguir editando
    </button>
    <button mat-raised-button color="primary" (click)="confirmar()">
      Confirmar
    </button>
  </div>
</div>


